import { useRef, useState } from 'react';
import { notification } from 'antd';
import XLSX from 'xlsx';
import { t } from '../i18n/i18n';

const useImportCsv = (keys, setLoading = () => {}) => {
  const [result, setResult] = useState(null);
  const importRef = useRef(null);

  const excelToJson = async (data) => {
    try {
      const returnData = [];
      data.forEach((row) => {
        if (row.length > 0) {
          returnData.push(
            keys.reduce((acum, key, index) => ({ ...acum, [key]: row[index] ?? '' }), {})
          );
        }
      });
      return returnData;
    } catch {
      notification.open({
        message: t('SCREENING_IMPORT_FILE_ERROR'),
        icon: <i className="fas fa-times" style={{ color: 'red' }} />,
      });
      return [];
    }
  };

  const validateFile = (file) =>
    [
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ].includes(file?.type);

  const readFile = () => {
    setLoading(true);
    const file = importRef.current.files[0];
    if (!validateFile(file)) {
      notification.open({
        message: t('SCREENING_IMPORT_FILE_ERROR'),
        icon: <i className="fas fa-times" style={{ color: 'red' }} />,
      });
      setLoading(false);
      return;
    }
    const reader = new FileReader();
    reader.addEventListener('load', async (event) => {
      const isCSV = file.type === 'text/csv';
      const readOptions = isCSV ? { type: 'string' } : { type: 'binary', raw: true };
      const workBook = XLSX.read(event.target.result, readOptions);
      const workSheetName = workBook.SheetNames[0];
      const workSheet = workBook.Sheets[workSheetName];
      const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 });
      const json = await excelToJson(fileData);
      if (json) {
        setResult(json);
      }
    });
    if (file.type === 'text/csv') {
      reader.readAsText(file, 'utf-8');
    } else {
      reader.readAsBinaryString(file);
    }
    importRef.current.value = '';
  };

  return { result, readFile, importRef, setResult };
};

export default useImportCsv;
